// Couleurs nommées d'une animation. Un document peut aussi écrire un hex
// `#rrggbb` (la transparence passe par `opacity`). Les noms gardent les animations dans la charte
// sans que l'IA ou l'auteur ait à connaître les codes.
//
// Valeurs : charte de l'app (preset Tailwind `primary`, `accent`, `ink`) et
// teintes de la méthode HORA (`HORA_METHOD` de @jeraisonne/db/cards — parité
// testée). La scène a son propre fond : elle ne suit pas le thème clair /
// sombre de l'app (comme les faces des SKILLCARDS).

export const JRAF_PALETTE = {
  night: '#061433',
  paper: '#ffffff',
  ink: '#18160f',
  muted: '#78746a',
  primary: '#0566f2',
  'primary-light': '#8eb4ff',
  accent: '#ff6e49',
  gold: '#f2c14e',
  'gold-light': '#ffe08a',
  green: '#2f9e44',
  red: '#e03131',
  'hora-h': '#3b5bdb',
  'hora-o': '#2f9e44',
  'hora-r': '#f08c00',
  'hora-a': '#e03131',
} as const;

export type JrafColorName = keyof typeof JRAF_PALETTE;

export const JRAF_COLOR_NAMES = Object.keys(JRAF_PALETTE) as JrafColorName[];

export const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

/** Couleur nommée ou hex → hex ; `none` reste `none`. */
export function resolveColor(color: string): string {
  if (color === 'none') return 'none';
  if (Object.prototype.hasOwnProperty.call(JRAF_PALETTE, color))
    return JRAF_PALETTE[color as JrafColorName];
  return color;
}
